import React, { forwardRef } from "react"
import map from "lodash/map"

export const questionList = {
  1: {
    question: "Who decides what the customer gets charged for your work?",
    name: "decidesHowMuch",
    answers: {
      a: {
        text: "A. Me",
        score: 0,
      },
      b: {
        text: "B. The Company",
        score: 10,
      },
    },
  },
  2: {
    question:
      "When you signed a contract with the company, was there an opportunity to negotiate the terms?",
    name: "negotiateTerms",
    answers: {
      a: {
        text: "A. Yes",
        score: 0,
      },
      b: {
        text: "B. No",
        score: 5,
      },
    },
  },
  3: {
    question:
      "Are you punished if you do not accept a job that is offered to you? (E.g. punishment could include not being offered new jobs for a period or being logged off an app).",
    name: "punishedNotAcceptingJob",
    answers: {
      a: {
        text: "A. Yes",
        score: 10,
      },
      b: {
        text: "B. No",
        score: 0,
      },
    },
  },
  4: {
    question:
      "Does the company you work for provide the main tools/equipment/vehicle needed to do the work?",
    name: "provideToolNeededForWork",
    answers: {
      a: {
        text: "A. Yes",
        score: 10,
      },
      b: {
        text: "B. No",
        score: 0,
      },
    },
  },
  5: {
    question:
      "Does the company you work for control the quality of the tools/equipment/vehicle needed to do the job? (E.g. tells you that you need a certain quality of car to work for them).",
    name: "doesCompnayControlTheQuality",
    answers: {
      a: {
        text: "A. Yes",
        score: 5,
      },
      b: {
        text: "B. No",
        score: 0,
      },
    },
  },
  6: {
    question:
      "Does the company operate a ratings system whereby if you receive a poor rating from customers you are punished? (E.g. If you receive a certain number of bad ratings you are terminated).",
    name: "opearateASystemPunished",
    answers: {
      a: {
        text: "A. Yes",
        score: 8,
      },
      b: {
        text: "B. No",
        score: 0,
      },
    },
  },
  7: {
    question:
      "Are you free to contact the customer after your job is complete?",
    name: "ableToContact",
    answers: {
      a: {
        text: "A. Yes",
        score: 0,
      },
      b: {
        text:
          "B. Yes but only in limited circumstances e.g. contacting them about lost property",
        score: 5,
      },
      c: {
        text: "C. No",
        score: 8,
      },
    },
  },
  8: {
    question: "Do you wear a uniform branded with the company you work for?",
    name: "wearBrandedUniform",
    answers: {
      a: {
        text: "A. Yes",
        score: 5,
      },
      b: {
        text: "B. No",
        score: 0,
      },
      c: {
        text: "C. Not applicable for the job I do",
        score: 0,
      },
    },
  },
  9: {
    question: "Do you drive a vehicle branded with the company you work for?",
    name: "brandedVehicle",
    answers: {
      a: {
        text: "A. Yes",
        score: 5,
      },
      b: {
        text: "B. No",
        score: 0,
      },
      c: {
        text: "C. Not applicable for the job I do",
        score: 0,
      },
    },
  },
  10: {
    question:
      "If you cannot do a job – are you able to send a substitute in your place? (I.e. can you ask someone else to do the job instead of you?).",
    name: "subsituteInYourPlace",
    answers: {
      a: {
        text: "A. Yes",
        score: 0,
      },
      b: {
        text: "B. Yes but that person needs to be qualified to do the work",
        score: 2,
      },
      c: {
        text: "C. Yes but that person needs to work for the same company",
        score: 6,
      },
      d: {
        text: "D. Yes but I need the consent of the company I work for first",
        score: 8,
      },
      e: {
        text: "E. No",
        score: 10,
      },
    },
  },
  11: {
    question: "Do you have control over your own working days and hours?",
    name: "controlOverHoursAndDays",
    answers: {
      a: {
        text: "A. Yes",
        score: 0,
      },
      b: {
        text:
          "B. Some control (e.g. I have to work certain days but can work the hours I want)",
        score: 4,
      },
      c: {
        text: "C. No",
        score: 10,
      },
    },
  },

  12: {
    question:
      "Does the company you work for have day to day supervision over how you do your work?",
    name: "dayToDaySupervision",
    answers: {
      a: {
        text: "A. Yes",
        score: 8,
      },
      b: {
        text: "B. No",
        score: 0,
      },
    },
  },
  13: {
    question:
      "Does the company you work for have an obligation to provide you with work?",
    name: "obligationToProvideYouWithWork",
    answers: {
      a: {
        text: "A. Yes",
        score: 10,
      },
      b: {
        text: "B. No",
        score: 0,
      },
    },
  },
}

export const Radio = forwardRef((props, ref) => {
  return (
    <input
      type="radio"
      className="form-radio h-8 w-8 text-green-500 cursor-pointer	"
      ref={ref}
      {...props}
    />
  )
})
